// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oYvXq","fullView":"styles_fullView__3mRgR"};